import React from "react";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const DateSelector = ({ value, onChange, label = "Shopping Date" }) => {
  const handleDateChange = (e) => {
    const isoDate = dayjs(e.target.value).startOf("day").toISOString();
    onChange(isoDate);
  };

  return (
    <TextField
      fullWidth
      type="date"
      label={label}
      value={value ? dayjs(value).format("YYYY-MM-DD") : ""}
      onChange={handleDateChange}
      size="small"
      InputLabelProps={{ shrink: true }}
      sx={{
        borderRadius: 2,
        backgroundColor: "#fff",
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
      }}
      inputProps={{
        style: {
          padding: "10px 12px",
        },
      }}
    />
  );
};

export default DateSelector;
